// extracted by mini-css-extract-plugin
module.exports = {"main":"main_2kcYai","danger":"danger__AJDGT","bold":"bold_3b10Lv"};